import {
  Breadcrumb as BreadcrumbComponent,
  BreadcrumbItem,
  BreadcrumbLink,
} from '@awazevr/design-system.components.breadcrumb'
import { Container } from '@awazevr/design-system.components.container'
import { pxToRems } from '@awazevr/design-system.utils.react'
import { BreadcrumbItems } from 'src/utils/breadcrumb/breadcrumb-utils'
import styled from 'styled-components'

interface BreadcrumbsProps {
  breadcrumbs: BreadcrumbItems[]
}

const BreadcrumbContainer = styled.div`
  overflow: hidden;
  padding: ${pxToRems(48)} ${pxToRems(24)} 0;
`

export default function Breadcrumb({
  breadcrumbs,
}: Readonly<BreadcrumbsProps>): JSX.Element {
  return (
    <BreadcrumbContainer>
      <Container>
        <BreadcrumbComponent>
          {breadcrumbs.map(
            ({ slug, url, name }, index) =>
              name && (
                <BreadcrumbItem key={slug + index} dense>
                  <BreadcrumbLink href={url}>{name}</BreadcrumbLink>
                </BreadcrumbItem>
              ),
          )}
        </BreadcrumbComponent>
      </Container>
    </BreadcrumbContainer>
  )
}
